import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useCurrentClubSlug_session$key } from "./__generated__/useCurrentClubSlug_session.graphql";

export const useCurrentClubSlug = (
  sessionRef: useCurrentClubSlug_session$key | null
) => {
  const session = useFragment(useCurrentClubSlugFragmentString, sessionRef);
  return session?.currentClientProfile?.member?.club?.slug;
};

export const useCurrentClubSlugFragmentString = graphql`
  fragment useCurrentClubSlug_session on Session {
    currentClientProfile {
      member {
        club {
          slug
        }
      }
    }
  }
`;
